import { MediaUploadError } from './mediaUploadError';

export async function parseJsonResponse<T>(response: Response): Promise<T> {
  const text = await response.text();
  if (!response.ok) {
    let responseJson: unknown;
    try {
      responseJson = JSON.parse(text) as unknown;
    } catch {
      responseJson = undefined;
    }
    throw new MediaUploadError(response.status, text, responseJson);
  }
  if (!text) {
    return null as T;
  }
  try {
    return JSON.parse(text) as T;
  } catch {
    throw new MediaUploadError(response.status, text);
  }
}
